/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { EventBusService } from '../../../../services/EventBusService';
import { KeyLabel } from '../models/discovery.models';
import { ReportConfig } from '../REPORT_CONFIG';
import { AppService } from '../../../../services/app-service';
import { DomainService } from '../../../../services/domain-service';
import { CtvService } from '../../../../services/ctv-service';
import {
  LOCALSTORAGE_KEY,
  LOCALSTORAGE_KEY_DOMAINS
} from '../discovery.component';
import { ActivatedRoute } from '@angular/router';
import { DiscoveryUtilFunctions } from '../discovery-util-functions';
import { TabbedFilterItemValue } from '../TABBED_FILTERS_CONFIG';
import { WatchlistService } from '../../../../services/watchlist-service';
import { User } from 'app/models/User';

declare var jQuery;

@Component({
  selector: 'app-discovery-download-csv',
  templateUrl: './download-csv.component.html',
  styleUrls: ['./download-csv.component.scss']
})
export class DownloadCsvComponent implements OnInit, OnChanges {
  @Input()
  totalCount: number;

  @Input()
  showFollowing: boolean;

  @Input()
  currentConfig: ReportConfig;

  @Input()
  appGlobalSearchParam: string;

  @Input()
  downloadButtonDisabled: boolean;

  @Input()
  downloadColumns: Array<KeyLabel>;

  @Input()
  importedFileName: string;

  @Input()
  canDownloadCSV: boolean;

  @Input()
  hideUnfilteredDownloadCsv: boolean;

  @Input()
  selectedFilterValues: TabbedFilterItemValue[];

  @Input()
  cannedreports: Array<any>;

  @Input()
  currentCannedReportUpdater: EventEmitter<any>;

  @Input()
  importedFileNameUpdater: EventEmitter<string>;

  @Input()
  followingCount: number;

  @Input()
  followIdMapping: any;

  @Input()
  watchlistTypeMapping: any;

  downloading: boolean;
  selectAllColumns: boolean;

  constructor(
    private _eventService: EventBusService,
    private _appService: AppService,
    private _domainService: DomainService,
    private _ctvService: CtvService,
    private _route: ActivatedRoute,
    private _watchlistService: WatchlistService,
    private _userService: User
  ) {}

  ngOnInit(): void {
    this._eventService.downloadCsvClickPopupEvent.subscribe(
      (proceed: boolean) => {
        if (proceed) {
          this.downloadCsv(false);
        }
      }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.downloadColumns) {
      this.updateSelectAllStatus();
      this.updateLocalStorage();
    }
  }

  updateLocalStorage() {
    const selectedColumns = this.downloadColumns.filter(
      column => column.selected
    );
    const discoverytype = this._route.snapshot.params['discoverytype'];
    let localStorageKey = LOCALSTORAGE_KEY;
    if (discoverytype === 'domains') {
      localStorageKey = LOCALSTORAGE_KEY_DOMAINS;
    }

    if (selectedColumns && selectedColumns[0]) {
      const lsValue = selectedColumns.map(column => column.key).join(',');
      localStorage.setItem(localStorageKey, lsValue);
    }
  }

  updateSelectAllStatus() {
    const count = this.downloadColumns.filter(col => col.selected).length;
    const allCount = this.downloadColumns.length;
    this.selectAllColumns = allCount > 0 && allCount === count;
  }

  toggleDownloadColumn(event: any, column: KeyLabel) {
    event.stopPropagation();
    column.selected = !column.selected;

    const found = this.downloadColumns.filter(col => col.selected);
    this.downloadButtonDisabled = !found || found.length <= 0;

    this.updateSelectAllStatus();
    this.updateLocalStorage();
  }

  toggleSelectAllColumns(event: any) {
    event.stopPropagation();
    this.selectAllColumns = !this.selectAllColumns;

    this.downloadColumns.forEach(column => {
      column.selected = this.selectAllColumns;
    });

    this.downloadButtonDisabled = !this.selectAllColumns;
    this.updateLocalStorage();
  }

  downloadWithPermission() {
    if (this.totalCount > 1000000) {
      return this._eventService.showDownloadCsvLimitPopup();
    }

    if (this._userService.hasPermission('quotaExpansion')) {
      this._eventService.showDownloadDeductionPopup(this.totalCount);
    } else {
      this.downloadCsv(false);
    }
  }

  downloadCsvWithColumns(event?: any, unFiltered?: boolean) {
    if (!this.downloadButtonDisabled) {
      this.downloadCsv(true, unFiltered);
    } else {
      if (event) {
        event.stopPropagation();
      }
    }
  }

  downloadCsv(withDownloadColumns: boolean, unFiltered?: boolean) {
    if (this.totalCount > 1000000) {
      this._eventService.showDownloadCsvLimitPopup();
    } else {
      let downloadService = null;
      const filterStrings = this.getFilterStrings(unFiltered);
      if (withDownloadColumns) {
        const selectedColumns = this.downloadColumns
          .filter(column => column.selected)
          .map(column => column.key);
        if (selectedColumns && selectedColumns[0]) {
          const selectedColumnsString = selectedColumns.join(',');
          filterStrings.push(`columns=${selectedColumnsString}`);
        }
      }

      if (this.showFollowing) {
        const type = this.currentConfig.key;
        const follows = this._watchlistService.watchlist.getFollowListByType(
          this.watchlistTypeMapping[type]
        );
        if (this.followingCount > 0) {
          follows.forEach(follow => {
            filterStrings.push(
              `${this.followIdMapping[type]}=${follow.followId}`
            );
          });
        } else {
          // temporary randomId to return no results
          filterStrings.push(`${this.followIdMapping[type]}=XXXX`);
        }
      }

      if (this.currentConfig.key === 'apps') {
        if (this.appGlobalSearchParam && this.appGlobalSearchParam.length > 0) {
          filterStrings.push(
            `appGlobalSearchParam=${this.appGlobalSearchParam}`
          );
        }
        downloadService = this._appService.downloadCsv(
          'appSearch',
          filterStrings.join('&')
        );
      } else if (this.currentConfig.key === 'domains') {
        downloadService = this._domainService.downloadCsv(
          filterStrings.join('&')
        );
      } else if (this.currentConfig.key === 'ctv') {
        downloadService = this._ctvService.downloadCsv(filterStrings.join('&'));
      }

      this.callDownloadService(downloadService);
    }
  }

  getFilterStrings(noMainFilters?: boolean, noSortBy?: boolean) {
    const bulkUploadReportId =
      this._route.snapshot.queryParams['bulkUploadReportId'];
    const filterStrings = DiscoveryUtilFunctions.getFilterStrings(
      this.currentConfig,
      this.selectedFilterValues,
      this.cannedreports,
      bulkUploadReportId,
      this.currentCannedReportUpdater,
      this.importedFileNameUpdater,
      noMainFilters,
      noSortBy
    );
    return filterStrings;
  }

  callDownloadService(downloadService: any) {
    if (downloadService) {
      this.downloading = true;
      let isExportFound = false;
      const hasPermission = this._userService.hasPermission('quotaExpansion');
      downloadService.then(exportUrl => {
        // MR-747, extra double quotes causing the URL to break, stripping it
        exportUrl = exportUrl.replace(/"/g, '');
        const intervalId = setInterval(fn => {
          jQuery.ajax({
            url: exportUrl,
            dataType: 'jsonp',
            timeout: 5000,
            success: sresponse => {},
            error: parsedjson => {
              if (!isExportFound) {
                if (
                  parsedjson.status === 200 ||
                  (parsedjson.readyState === 0 &&
                    parsedjson.status === 0 &&
                    parsedjson.statusText === 'timeout')
                ) {
                  clearInterval(intervalId);
                  isExportFound = true;
                  this.downloading = false;
                  window.location.href = exportUrl;
                } else if (hasPermission && parsedjson.readyState === 4) {
                  // Handle error
                  clearInterval(intervalId);
                  isExportFound = true;
                  this.downloading = false;
                  this._eventService.showQuotaError(
                    'Download failed due to insufficient quota.',
                    false
                  );
                }
              }
            }
          });
        }, 5005);
      });
    }
  }
}
